module.exports = __webpack_public_path__ + "static/media/Close.a1fa96c0.svg";